import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';
import { getSafe } from 'helpers';

import * as ACTIONS from './entity-map-view.actions';
import { initialState } from './entity-map-view.state';

const _entityMapViewReducers = createReducer(initialState,
  produceOn(ACTIONS.DATA_LOADING, (state) => {
    state.dataLoading = true;
  }),
  produceOn(ACTIONS.RUN_QUERY_CLICKED, (state) => {
    state.mapPosition.shouldFitMap = true;
  }),
  produceOn(ACTIONS.RESET_QUERY_CLICKED, (state) => {
    state.mapPosition.shouldFitMap = true;
  }),
  produceOn(ACTIONS.ENTITIES_FETCHED, (state, props) => {
    state.queryResult = props.payload;
    state.dataLoading = false;
  }),
  produceOn(ACTIONS.SET_CURRENT_QUERY, (state, props) => {
    state.dataLoading = true;
    state.currentQuery = props.payload;
  }),
  produceOn(ACTIONS.SET_SELECTED_MARKER, (state, props) => {
    state.selectedMarker = props.payload;
  }),
  produceOn(ACTIONS.UPDATE_ENTITY_TAB_CARD_COLLAPSED_STATE, (state, props) => {
    // If card settings exits
    if (getSafe(() => state.selectedMarker.markerDisplayState.tabbedCardStates[props.entityId], null)) {
      state.selectedMarker.markerDisplayState.tabbedCardStates[props.entityId].collapsed = props.isCollapsed;
      return;
    }

    // A bunch of null checks to populate data
    if (!state.selectedMarker.markerDisplayState) {
      state.selectedMarker.markerDisplayState = {
        tabbedCardStates: {}
      };
    }

    if (!state.selectedMarker.markerDisplayState.tabbedCardStates) {
      state.selectedMarker.markerDisplayState.tabbedCardStates = {};
    }

    state.selectedMarker.markerDisplayState.tabbedCardStates[props.entityId] = {
      collapsed: props.isCollapsed,
      selectedTab: 'profile'
    };
  }),
  produceOn(ACTIONS.UPDATE_ENTITY_TAB_CARD_SELECTED_TAB, (state, props) => {
    // If card settings exits
    if (getSafe(() => state.selectedMarker.markerDisplayState.tabbedCardStates[props.entityId], null)) {
      state.selectedMarker.markerDisplayState.tabbedCardStates[props.entityId].selectedTab = props.tab;
      return;
    }

    // A bunch of null checks to populate data
    if (!state.selectedMarker.markerDisplayState) {
      state.selectedMarker.markerDisplayState = {
        tabbedCardStates: {}
      };
    }

    if (!state.selectedMarker.markerDisplayState.tabbedCardStates) {
      state.selectedMarker.markerDisplayState.tabbedCardStates = {};
    }

    state.selectedMarker.markerDisplayState.tabbedCardStates[props.entityId] = {
      collapsed: false,
      selectedTab: props.tab
    };
  }),
  produceOn(ACTIONS.SET_MAP_POSITION, (state, props) => {
    state.mapPosition = { ...props.payload, ...{ shouldFitMap: false } };
  }),
  produceOn(ACTIONS.RESET_MAP_STATE, (state, props) => {
    Object.assign(state, initialState);
  })
);

export function entityMapViewReducers(state, action) {
  return _entityMapViewReducers(state, action);
}
